/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {Link, useParams} from 'react-router-dom'
import { approve } from '../core/_requests'
import { useIntl } from 'react-intl'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

export function ApprovePage() {    
    const { approvalGuid } = useParams();
    const intl = useIntl();
    const lang = useLang()

  const [loading, setLoading] = useState(false)
  const [approvedText, setApprovedText] = useState("")
  //const {saveAuth, setCurrentUser} = useAuth()  

  useEffect(() => {
  const fetchData = async () => {
    const {data} = await approve(approvalGuid || "");    
    setApprovedText(intl.formatMessage({ id: 'Your Email has been approved' }));    
  };

  fetchData();
}, [approvalGuid]);

  return (
    <>{approvedText}
     <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
                      {useIntl().formatMessage({ id: 'Login' })}
          </button>
        </Link>
    </>
  )
}
